export const flexCentered = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}
